// Google Analytics helper functions
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

// Track page sections viewed
export const trackSectionView = (sectionName) => {
  trackEvent('section_view', {
    section_name: sectionName,
    page_location: window.location.href
  });
};

// Track button clicks
export const trackButtonClick = (buttonName, buttonLocation) => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: buttonLocation
  });
};

// Track form events
export const trackFormStart = (formType) => {
  trackEvent('form_start', {
    form_type: formType
  });
};

export const trackFormSubmit = (formType) => {
  trackEvent('generate_lead', {
    form_type: formType,
    currency: 'HUF',
    value: 1
  });
  // Also track as conversion
  trackEvent('conversion', {
    send_to: 'G-N957XZ8K4N',
    form_type: formType
  });
};
